<template>
<div>
	<div>
		<div class="col-lg-12">
			<h2 class="page-header">
				<span id="page-header">Profil von {{ model.model.firstname }} {{ model.model.lastname }}</span>
				<button class="btn btn-warning pull-right" @click="$router.back()">Zurück</button>
			</h2>

			<div class="row">
				<h3 class="col-lg-12">Allgemeine Informationen  <router-link class="btn btn-primary create-new pull-right" to="/users/new"><i class="fa fa-plus"></i></router-link></h3>
				<div class="form-horizontal" id="customer-information">

					<div class="row">
						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="firstname">Vorname</label>
								<div class="col-sm-12">
									<input id="firstname" name="firstname" class="form-control" v-model="model.model.firstname" required>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="lastname">Nachname</label>
								<div class="col-sm-12">
									<input id="lastname" name="lastname" class="form-control" v-model="model.model.lastname" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="username">Loginname</label>
								<div class="col-sm-12">
									<input id="username" name="username" class="form-control" v-model="model.model.username" readonly="readonly">
								</div>
							</custom-input>
						</div>

						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="password">Passwort</label>
								<div class="col-sm-12">
									<input id="password" name="password" class="form-control" v-model="model.model.password" type="password" :placeholder="model.model.id === 0 ? 'Passwort eingeben' : '[Nicht ändern]'" required>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="repassword">Passwort wiederholen</label>
								<div class="col-sm-12">
									<input id="repassword" name="password" class="form-control" v-model="model.model.repassword" type="password" :placeholder="model.model.password === '' ? '[Nicht ändern]' : 'Passwort wiederholen'" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="superior">Vorgesetzter</label>
								<div class="col-sm-12">
									<input id="superior" class="form-control" v-model="model.model.superior_name" readonly="readonly">
								</div>
							</custom-input>
						</div>

						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="role">Rolle</label>
								<div class="col-sm-12">
									<input id="role" name="role" class="form-control" required="required" v-model="model.model.role_name" readonly="readonly">
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="form-group">
							<div class="col-lg-12 text-center">
								<button class="btn btn-primary" @click="updateProfile()">Speichern</button>
							</div>
						</div>
					</div>


					<div class="row">
						<div class="col-lg-12">
							<div class="col-lg-12">
								<ul class="nav nav-tabs responsive-tabs">
									<li class="active"><a href="#addresses">Adressen</a></li>
									<li><a href="#contacts">Kontakte</a></li>
								</ul>

								<div class="tab-content col-lg-12">
									<div class="tab-pane active" id="addresses">
										<custom-table :cols="addresses.cols" :src-model="model.addresses" add delete edit nosort @add="addAddress" @edit="editAddress" @delete="deleteAddress"></custom-table>
									</div>

									<div class="tab-pane" id="contacts">
										<custom-table :cols="contacts.cols" :src-model="model.contacts" add delete edit nosort @add="addContact" @edit="editContact" @delete="deleteContact"></custom-table>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Adressen -->
		<custom-modal ref="addressModal" title="Adresse hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
			<address-content ref="newAddress"></address-content>
		</custom-modal>

		<custom-modal-old v-if="visibleModal === 'deleteaddresses'" title="Adresse löschen" ok-text="Löschen" cancel-text="Abbrechen" cancel-style="btn btn-primary" @ok="confirmDeleteRelation('addresses')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diese Adresse entfernen möchten?</strong>
		</custom-modal-old>




		<!-- Kontakt -->
		<custom-modal ref="contactModal" title="Kontakt hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
			<contact-content ref="newContact"></contact-content>
		</custom-modal>

		<custom-modal-old title="Kontakt entfernen" v-if="visibleModal === 'deletecontacts'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('contacts')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?</strong>
		</custom-modal-old>

		<!-- Fehlermeldungen -->
		<custom-modal-old v-if="visibleModal === 'errSavingModel'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
			Fehler beim Speichern des Kunden.
		</custom-modal-old>

		<custom-modal-old title="Fehler" v-if="visibleModal === 'incorrectPassword'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
			Passwörter stimmen noch nicht überein.
		</custom-modal-old>
	</div>
</div>

</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal.vue'
import CustomModalOld from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'
import AddressContent from 'components/address-content.vue'
import ContactContent from 'components/contact-content.vue'

import Datepicker from 'vuejs-datepicker'
import vueSlider from 'vue-slider-component';

import UserModel from 'models/users.js'
import AddressesModel from 'models/addresses.js'
import ContactsModel from 'models/contacts.js'

import relationTools from 'functions/relations.js'
import addressTools from 'functions/address.js'
import contactTools from 'functions/contact.js'

import store from 'root/store.js'
import { authCheck, getSuperiorID, getUserID } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('profile')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	// Normale Eigenschaften
	data () {
		return {
			model: UserModel,

			// visibleModal: 'addgraves'
			visibleModal: '',

			defSort: {col: 'id', order: 'asc'},

			addresses: AddressesModel,
			contacts: ContactsModel,
		}
	},

	activated () {
		this.model.clear()
		this.model.model.id = getUserID()

		$('.responsive-tabs').responsiveTabs({
			accordionOn: ['xs', 'sm'] // xs, sm, md, lg
		})

		axios.get('/api/session/')
		.then(response => {
			this.model.copy(response.data)
		})
		.then(() => this.$store.dispatch('loadModels', this.model.relations))
	},

	components: {
		CustomTable,
		CustomModal,
		CustomModalOld,
		CustomInput,
		Datepicker,
		vueSlider,
		AddressContent,
		ContactContent
	},

	methods: {
		updateProfile () {
			if ((this.model.model.password.trim() === '') || (this.model.model.password === this.model.model.repassword)) {
				axios.put('/api/session/' + Date.now(), this.model.model)
				.then(response => console.log(response))
			} else {
				this.visibleModal = 'incorrectPassword'
			}
		},

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		saveAddress () {
			if (this.addresses.model.id === 0) {
				axios.post('/api/session/addresses/', this.addresses.model)
				.then(response => {
					this.model.addresses = response.data
					this.visibleModal = ""
				})
			} else {
				axios.put('/api/session/addresses/' + this.addresses.model.id, this.addresses.model)
				.then(response => {
					this.model.addresses = response.data
					this.visibleModal = ""
				})
			}
		},

		// Adress speziefische Methoden
		addressModal () {
			this.$refs.addressModal.open( () => {
				// Callback um zzu prüfen ob das Modal geschlossen werden kann
				if (this.$refs.newAddress.model.model.street.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.number.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.zip.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.city.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveAddress()
			})
			.catch(() => {
				// Erfolgloses schließen
				console.log("CANCEL")
			})
		},

		addAddress () {
			this.addresses.clear()
			this.addressModal()
		},

		// Adressen speziefische Methoden
		editAddress (aModel) {
			this.addresses.copy(aModel)
			this.addressModal()
		},

		deleteAddress: addressTools.delete,

		/* deleteAddress (aModel) {
			axios.delete('/api/session/addresses/' + aModel.id)
			.then(response => {
				this.model.addresses = response.data
				this.visibleModal = ""
			})
			.catch(response => console.log("Error!", response))
		}, */

		// Kontakt speziefische Methoden
		saveContact () {
			if (this.contacts.model.id === 0) {
				axios.post('/api/session/contacts/', this.contacts.model)
				.then(response => {
					this.model.contacts = response.data
					this.visibleModal = ""
				})
			} else {
				axios.put('/api/session/contacts/' + this.contacts.model.id, this.contacts.model)
				.then(response => {
					this.model.contacts = response.data
					this.visibleModal = ""
				})
			}
		},

		contactModal () {
			this.$refs.contactModal.open( () => {
				this.saveContact()

				return true
			})
			.then(() => {
				this.saveRelation('contacts')
			})
			.catch(() => {
				// Erfolgloses schließen
				console.log("CANCEL")
			})
		},

		addContact () {
			this.contacts.clear()
			this.contactModal()
		},

		// Adressen speziefische Methoden
		editContact (aModel) {
			this.contacts.copy(aModel)
			this.contactModal()
		},

		deleteContact: contactTools.delete,

		/*deleteContact (aModel) {
			axios.delete('/api/session/contacts/' + aModel.id)
			.then(response => {
				this.model.contacts = response.data
				this.visibleModal = ""
			})
			.catch(response => console.log("Error!", response))
		}, */

		saveUser () {
			this.saveModel()
			.then(id => {
				this.model.model.id = id
				this.$router.replace("/users/" + id)
			})
			.catch(id => {
				this.model.model.id = id
			})

		}
	}
}
</script>



// WEBPACK FOOTER //
// Profile.vue?42e653dc